import type { State } from '../../types.tsx';
import { getConfig } from '../config/index.tsx';

export const getFirstLevelHierarchyName = (state: State): string | null =>
	getConfig(state).hierarchyNomenclature?.firstLevelName ?? null;
